import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app/App';
import { StoreProvider, RootStore } from './app/providers/StoreProvider';
import { preloadAllImages } from './shared/utils/preload';
import 'dayjs/locale/ru';
import ruRU from 'antd/locale/ru_RU';
import { ConfigProvider } from 'antd';
import dayjs from './shared/lib/dayjs';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

dayjs.locale('ru');

async function app() {
  await preloadAllImages(); 
  const store = new RootStore();
  root.render(
    <ConfigProvider locale={ruRU}>
    <StoreProvider value={store}>
      <App />
    </StoreProvider>
    </ConfigProvider>
  );
}
app();
